import { lang } from '@umu/ukit-lang';
/**
 * @description
 */

import './sectionTextareaResultList.scss';

import React from 'react';
import { components } from 'common';
const { Loading } = components;
import { ISectionOptionResultContent } from '@umu/umu-types';
import FormTextareaResultList from '../@formTextareaResultList/formTextareaResultList';
import SectionRadioboxResultList from '../@sectionRadioboxResultList/sectionRadioboxResultList';

export default class SectionTextareaResultList extends SectionRadioboxResultList {
    public render() {
        return super.render();
    }

    public renderFormResult() {
        const { userCount, resultList } = this.props.sectionInfo;
        return (
            <FormTextareaResultList userCount={userCount} resultList={resultList as ISectionOptionResultContent[]} />
        );
    }

    public renderMoreAction() {
        const { resultList = [], userCount = 0 } = this.props.sectionInfo;

        if (userCount <= resultList.length) {
            return null;
        }

        const actionLabel = lang('更多 >');

        return (
            <div className="section-textarea-result-more">
                <div className="action" onClick={this.onShow}>
                    {actionLabel}
                </div>
            </div>
        );
    }

    public renderSectionMoreBody() {
        const renderList = this.state.panelData.list;
        return (
            <>
                <FormTextareaResultList resultList={renderList} />
                {this.state.loading ? <Loading /> : null}
            </>
        );
    }
}
